import jwtDecode from 'jwt-decode';
import { getCookie } from "./utils"
import { useEffect } from 'react';
import CookiesHelper from './utils/cookiesHelper';

const ProtectedRoute = ({ children ,sessionHandler}) => {
    const voAuthToken = CookiesHelper.getAccessToken()
    const urlParams = new URLSearchParams(window.location.search);
    const authTokenValue = urlParams.get('token');

    useEffect(()=>{
        if(authTokenValue)
            return 
        if (!voAuthToken) {
            return sessionHandler();
        }
        
    },[voAuthToken])

    return (children);
};

export default ProtectedRoute;